<template>
  <div class="datamain">
    <Header />

    <div class="datamenubox">
      <div
        :class="menu == 'growUp' ? 'datamenuitem died' : 'datamenuitem'"
        @click="menuchange('growUp')"
        v-if="getAllMenuCodes && getAllMenuCodes.includes('2UrG7oVB')"
      >
        生长时期
      </div>
      <div
        :class="menu == 'tesk' ? 'datamenuitem died' : 'datamenuitem'"
        @click="menuchange('tesk')"
        v-if="getAllMenuCodes && getAllMenuCodes.includes('b5qpjGWw')"
      >
        农事任务
      </div>
    </div>
    <div class="databox">
      <growUp v-if="menu == 'growUp'" :sbname="sbname" />
      <tesk
        v-if="menu == 'tesk'"
        :sbname="sbname"
        :defaultTab="taskMenu"
        @tab-change="handleTaskTabChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import growUp from "./components/growUp.vue";
import tesk from "./components/tesk.vue";
import Header from "../Header.vue";
export default {
  name: "index",
  components: {
    Header,
    growUp,
    tesk,
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
  },
  data() {
    return {
      menu: "growUp",
      sbname: "",
      drawer: false,
      taskMenu: "",
    };
  },
  mounted() {
    this.syncMenuWithRoute();
  },
  methods: {
    menuchange(menu) {
      this.menu = menu;
      this.updateRouteQuery(menu);
    },
    handleClose() {
      this.drawer = false;
    },
    handleTaskTabChange(tab) {
      this.taskMenu = tab;
      this.updateRouteQuery(this.menu, tab);
    },
    syncMenuWithRoute() {
      const { menu, taskTab } = this.$route.query;

      // 检查用户是否有权限访问指定菜单，如果没有则选择有权限的默认菜单
      if (menu === "tesk" || menu === "growUp") {
        if (this.hasMenuPermission(menu)) {
          this.menu = menu;
        } else {
          this.menu = this.getDefaultMenuWithPermission();
        }
      } else {
        // 如果路由中没有指定菜单或无效，使用有权限的默认菜单
        this.menu = this.getDefaultMenuWithPermission();
      }

      if (taskTab === "history" || taskTab === "assign") {
        this.taskMenu = taskTab;
      }
    },
    hasMenuPermission(menu) {
      const menuCodes = this.getAllMenuCodes || [];
      switch (menu) {
        case "growUp":
          return menuCodes.includes("2UrG7oVB");
        case "tesk":
          return menuCodes.includes("b5qpjGWw");
        default:
          return false;
      }
    },
    getDefaultMenuWithPermission() {
      const menuCodes = this.getAllMenuCodes || [];

      // 优先选择生长时期，如果有权限
      if (menuCodes.includes("2UrG7oVB")) {
        return "growUp";
      }
      // 其次选择农事任务，如果有权限
      if (menuCodes.includes("b5qpjGWw")) {
        return "tesk";
      }
      // 如果都没有权限，返回空字符串或默认值
      return "";
    },
    updateRouteQuery(menu, taskTab = this.taskMenu) {
      const query = {
        ...this.$route.query,
        menu,
        taskTab,
      };
      if (
        this.$route.query.menu === query.menu &&
        this.$route.query.taskTab === query.taskTab
      ) {
        return;
      }
      this.$router.replace({ path: this.$route.path, query });
    },
  },
  watch: {
    $route: {
      handler() {
        this.syncMenuWithRoute();
      },
      immediate: false,
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: "title";
  src: url("../../assets/font/title.ttf");
}

.datamain {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #030a2e;

  .datamenubox {
    margin: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;

    .datamenuitem {
      padding: 10px 20px;
      color: #fff;
      font-size: 22px;
      cursor: pointer;
      background-image: url("../../assets/img/data/btn.png");
      background-size: 100% 100%;
    }

    .died {
      background-image: url("../../assets/img/data/btned.png");
    }
  }

  .databox {
    margin: 10px;
    width: calc(100% - 20px);
    height: calc(100% - 160px);
    background: rgba(0, 11, 47, 0.5);
    box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
    border-radius: 0px 0px 0px 0px;
    padding: 10px;
    display: flex;
  }
}
</style>
